import { List, ListItemButton, ListItemText } from "@mui/material";

const navigationButtons = [
  { label: "Info generali", value: "genericInfo" },
  { label: "Storico colture", value: "cropHistory" },
  { label: "Mappa", value: "fieldMap" },
  { label: "Sottoterreni", value: "subAreas" },
  { label: "Elimina terreno", value: "deleteField" },
];

const UpdateFieldNavigation = ({
  theme,
  selectedItem,
  onItemSelect,
  hasSubAreas,
}) => {
  const filteredNavigationButtons = navigationButtons.filter((item) => {
    if (item.value === "subAreas" && !hasSubAreas) {
      return false;
    }
    return true;
  });
  return (
    <List>
      {filteredNavigationButtons.map((item) => {
        const listItem = (
          <ListItemButton
            key={item.value}
            selected={selectedItem === item.label}
            onClick={() => onItemSelect(item.label)}
            sx={{
              "&.Mui-selected": {
                backgroundColor: theme.palette.primary.main,
                color: "white",
              },
            }}
          >
            <ListItemText primary={item.label} />
          </ListItemButton>
        );

        return listItem;
      })}
    </List>
  );
};

export default UpdateFieldNavigation;
